import searchRequest from "api/search";
import { useState } from "react";

const useSearch = () => {
  const [loading, setloading] = useState(true);
  const [results, setresults] = useState([]);

  const submit = (search, filters, sort) => {
    doSearch(search, filters, sort);
  };

  const doSearch = (search, filters, sort) => {
    setloading(true);
    searchRequest(search, filters, sort)
      .then((data) => {
        setloading(false);
        setresults(data);
      })
      .catch((e) => console.log(e));
  };

  return { results, loading, submit };
};

export default useSearch;
